"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Network = void 0;
var types_1 = require("@web3-react/types");
var utils_1 = require("./utils");
function isUrl(url) {
  return typeof url === 'string' || 'url' in url && !('connection' in url);
}
var Network = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(Network, _types_1$Connector);
  var _super = _createSuper(Network);
  function Network(_ref) {
    var _this;
    var actions = _ref.actions,
      urlMap = _ref.urlMap,
      _ref$defaultChainId = _ref.defaultChainId,
      defaultChainId = _ref$defaultChainId === void 0 ? Number(Object.keys(urlMap)[0]) : _ref$defaultChainId,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout;
    _classCallCheck(this, Network);
    _this = _super.call(this, actions);
    _this.providerCache = {};
    _this.urlMap = Object.keys(urlMap).reduce(function (accumulator, chainId) {
      var urls = urlMap[Number(chainId)];
      if (Array.isArray(urls)) {
        accumulator[Number(chainId)] = urls;
      } else {
        // this ternary just makes typescript happy, since it can't infer that the array has elements of the same type
        accumulator[Number(chainId)] = isUrl(urls) ? [urls] : [urls];
      }
      return accumulator;
    }, {});
    _this.defaultChainId = defaultChainId;
    _this.timeout = timeout;
    return _this;
  }
  _createClass(Network, [{
    key: "isomorphicInitialize",
    value: function isomorphicInitialize(chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var urls;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.providerCache[chainId]) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", this.providerCache[chainId]);
            case 2:
              urls = this.urlMap[chainId]; // early return if we have a single jsonrpc provider already
              if (!(urls.length === 1 && !isUrl(urls[0]))) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", this.providerCache[chainId] = Promise.resolve(urls[0]));
            case 5:
              return _context.abrupt("return", this.providerCache[chainId] = Promise.resolve().then(function () {
                return __importStar(require('@ethersproject/providers'));
              }).then(function (_ref2) {
                var JsonRpcProvider = _ref2.JsonRpcProvider;
                var providers = urls.map(function (url) {
                  return isUrl(url) ? new JsonRpcProvider(url, chainId) : url;
                });
                return (0, utils_1.getBestProvider)(providers, _this2.timeout);
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Initiates a connection.
     *
     * @param desiredChainId - The desired chain to connect to.
     */
  }, {
    key: "activate",
    value: function activate() {
      var desiredChainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultChainId;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;
        var cancelActivation;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.providerCache[desiredChainId]) {
                cancelActivation = this.actions.startActivation();
              }
              return _context3.abrupt("return", this.isomorphicInitialize(desiredChainId).then(function (customProvider) {
                return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                  var _yield$this$customPro, chainId;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        this.customProvider = customProvider;
                        _context2.next = 3;
                        return this.customProvider.getNetwork();
                      case 3:
                        _yield$this$customPro = _context2.sent;
                        chainId = _yield$this$customPro.chainId;
                        this.actions.update({
                          chainId: chainId,
                          accounts: []
                        });
                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, this);
                }));
              }).catch(function (error) {
                cancelActivation === null || cancelActivation === void 0 ? void 0 : cancelActivation();
                throw error;
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }]);
  return Network;
}(types_1.Connector);
exports.Network = Network;